<template>
<div v-if="team">
    <div class="row">
        <div class="large-12 columns large-centered">
            <table>
                <thead>
                <tr>
                  <th width="10%"></th>
                  <th witdh="20%"></th>
                  <th width="20%">Actuels</th>
                  <th width="20%">Révoqués</th>
                  <th width="20%"></th>
                </tr>
                </thead>
                <tbody class="roster">
                    <tr>
                        <td><img class="team-icon" src="/static/imgs/icons/dices.png" alt=""></td>
                        <td>Relances</td>
                        <td>{{team.nb_rerolls}}</td>
                        <td>{{revokedRerolls}}</td>
                        <td>
                            <button :disabled="team.nb_rerolls - revokedRerolls <= 0" @click="revokedRerolls++" class="alert small action">
                              <span><i class="fa fa-trash-o" aria-hidden="true"></i></span>
                            </button>
                            <button :disabled="revokedRerolls === 0" @click="revokedRerolls--" class="small action">
                              <span><i class="fa fa-undo" aria-hidden="true"></i></span>
                            </button>
                        </td>
                    </tr>
                    <tr v-if ="team.apo">
                        <td><img class="team-icon" src="/static/imgs/icons/red-cross.png" alt=""></td>
                        <td>Apothicaire</td>
                        <td v-if="team.apo">Oui</td>
                        <td v-else>Non</td>
                        <td v-if="revokedApo">Oui</td>
                        <td v-else>Non</td>
                        <td>
                            <button :disabled="revokedApo===1" @click="revokedApo++" class="alert small action">
                              <span><i class="fa fa-trash-o" aria-hidden="true"></i></span>
                            </button>
                            <button :disabled="revokedApo===0" @click="revokedApo--" class="small action">
                              <span><i class="fa fa-undo" aria-hidden="true"></i></span>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td><img class="team-icon" src="/static/imgs/icons/coach.png" alt=""></td>
                        <td>Assistants</td>
                        <td>{{team.assistants}}</td>
                        <td>{{revokedAssistants}}</td>
                        <td class="action">
                            <button :disabled="team.assistants - revokedAssistants <= 0" @click="revokedAssistants++" class="alert small action">
                              <span><i class="fa fa-trash-o" aria-hidden="true"></i></span>
                            </button>
                            <button :disabled="revokedAssistants === 0" @click="revokedAssistants++"class="small action">
                              <span><i class="fa fa-undo" aria-hidden="true"></i></span>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td><img class="team-icon" src="/static/imgs/icons/pom-pom.png" alt=""></td>
                        <td>Pom-pom girls</td>
                        <td>{{team.cheerleaders}}</td>
                        <td>{{revokedPompoms}}</td>
                        <td class="action">
                            <button :disabled="team.cheerleaders - revokedPompoms <= 0" @click="revokedPompoms++" class="alert small action">
                              <span><i class="fa fa-trash-o" aria-hidden="true"></i></span>
                            </button>
                            <button :disabled="revokedPompoms === 0" @click="revokedPompoms--"class="small action">
                              <span><i class="fa fa-undo" aria-hidden="true"></i></span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div v-else>
  <spinner></spinner>
</div>
</template>

<script>
import spinner from '../../common/spinner.vue'

export default {
  name: 'StuffRevokes',
  components: {
    spinner
  },
  props: {
    'team': {}
  },
  data () {
    return {
      revokedApo: 0,
      revokedRerolls: 0,
      revokedAssistants: 0,
      revokedPompoms: 0
    }
  },
  watch: {
    revokedApo: function (val) {
      this.$emit('updateRevokedStuff')
    },
    revokedRerolls: function (val) {
      this.$emit('updateRevokedStuff')
    },
    revokedAssistants: function (val) {
      this.$emit('updateRevokedStuff')
    },
    revokedPompoms: function (val) {
      this.$emit('updateRevokedStuff')
    }
  },
  methods: {
    getStuffToRevokeList: function () {
      let struct = null
      if (this.revokedApo ||
          this.revokedRerolls ||
          this.revokedAssistants ||
          this.revokedPompoms) {
        struct = {}
        struct.revokedApo = this.revokedApo
        struct.revokedRerolls = this.revokedRerolls
        struct.revokedAssistants = this.revokedAssistants
        struct.revokedPompoms = this.revokedPompoms
      }
      console.log(struct)
      return struct
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.roster{
    font-weight: 300;
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

.roster tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size:0.7rem;
}

.roster tr td.sous-total{
    font-weight: 400;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{

}

button.row{
    margin-left: 0.4rem;
}

.team-score {
    font-size: 2rem;
    font-weight: 450;
    padding-top: 1rem;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.match-result {
    font-size: 1.2rem;
    font-weight: 200;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.match-team-name {
    font-size: 1.7rem;
    font-weight: 300;
    padding-top: 1rem;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}
.roster tr td.action{
    padding: 0.4rem 0.3rem;
}

button.action {
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 0.8rem;
    font-weight: 600
}
button:disabled {
  background-color: #959fa5;
}
.note {
    font-weight: 100;
    font-size: 0.8rem;
}
.error {
  color:#E7505A;
}
.wait {
  cursor: wait;
}
</style>



// WEBPACK FOOTER //
// stuff-revoke.vue?47eb2667